// extracted by mini-css-extract-plugin
export default {"formControl":"search_formControl__pDP1l"};